<template>
  <div class="rounded border border-gray-400 bg-white divide-y overflow-hidden">
    <div
      v-if="title"
      class="flex p-4 space-x-4 cursor-pointer hover:bg-gray-100"
      @click="expanded = !expanded"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-6 h-6 text-gray-600"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path v-if="expanded" d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z" />
        <path v-else d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z" />
      </svg>
      <h3 class="text-base font-medium uppercase">
        {{ title }}
      </h3>
    </div>
    <div v-if="expanded" class="flex items-center p-4">
      <div class="space-x-2">
        <BaseButton v-if="allSelected" primary small @click="selectNone"> Deselect all </BaseButton>
        <BaseButton v-else primary small @click="selectAll"> Select all </BaseButton>
        <BaseButton v-if="anySelected" primary small @click="$emit('edit-multiple')">
          Edit collection
        </BaseButton>
      </div>
    </div>
    <ul v-if="expanded" class="grid grid-cols-5 gap-4 p-4">
      <li v-for="projectAsset in projectAssets" :key="projectAsset.id">
        <ProjectAssetTile
          :project-asset="projectAsset"
          :can-manage="canManage"
          :on-project-asset-delete="handleProjectAssetDelete"
          @manage-reviews="$emit('manage-reviews', $event)"
          @review="$emit('review', $event)"
          @edit="$emit('edit', $event)"
          @edit-link="$emit('edit-link', $event)"
          @edit-note="$emit('edit-note', $event)"
          @view-note="$emit('view-note', $event)"
        >
          <template #default="projectAssetProps">
            <label v-if="canManage" class="inline-block truncate text-sm">
              <input type="checkbox" :value="projectAsset.id" v-model="selectedGroup" />
              <span class="ml-2">
                {{ projectAssetProps.title }}
              </span>
            </label>
          </template>
        </ProjectAssetTile>
      </li>
    </ul>
  </div>
</template>

<script>
import { uniq } from 'lodash-es';
import ProjectAssetTile from './ProjectAssetTile.vue';

export default {
  name: 'ProjectAssetGroup',
  components: {
    ProjectAssetTile,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    canManage: Boolean,
    projectAssets: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      expanded: true,
    };
  },
  computed: {
    selectedGroup: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit('update:selected', value);
      },
    },
    projectAssetIds() {
      return this.projectAssets.map((p) => p.id);
    },
    noneSelected() {
      return this.projectAssetIds.every((id) => this.selected.indexOf(id) === -1);
    },
    allSelected() {
      return this.projectAssetIds.every((id) => this.selected.indexOf(id) > -1);
    },
    anySelected() {
      return this.projectAssetIds.some((id) => this.selected.indexOf(id) > -1);
    },
  },
  methods: {
    selectAll() {
      const uniqueIds = uniq([...this.selected, ...this.projectAssetIds]);
      this.$emit('update:selected', uniqueIds);
    },
    selectNone() {
      const remainingIds = this.selected.filter((id) => this.projectAssetIds.indexOf(id) === -1);
      this.$emit('update:selected', remainingIds);
    },
    async handleProjectAssetDelete(projectAsset) {
      try {
        await this.$store.dispatch({
          type: 'ui/projectProjectAssets/destroy',
          projectId: projectAsset.projectId,
          projectAssetId: projectAsset.id,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject();
      }
    },
  },
};
</script>
